import { WorkModel } from '@Entities/work/work'
import { ExtendedWorkFieldType } from '@Components/WorkItemV2/ExtendedWorkItem'

export const getCatalogWorkFields = (work: WorkModel): ExtendedWorkFieldType[] => {
    const fields: ExtendedWorkFieldType[] = []

    if (work.alternativeTitles.length > 0) {
        fields.push({
            title: 'Alternative Titles',
            value: work.alternativeTitles.map((aka) => aka.title).join(', '),
        })
    }
    fields.push({ title: 'MLC Song Code', value: work.songCode })
    fields.push({ title: 'ISWC', value: work.iswc })

    if (work.rightsholderProprietaryId) {
        fields.push({ title: 'Member Work Identifier', value: work.rightsholderProprietaryId })
    }
    return fields
}
